const AnaSelectOptions= {
    "P21": "Transcriptome of Lotus Seed Cotyledon Development",
    "P15": "Transcriptome of Lotus Seed Plumule Development",
    "P18": "Comparative Transcriptome of Lotus Seed Cotyledon Development",
    "USS15": "Transcriptome of Lotus under Submergence Stress",
    "FLS12": "Transcriptome of Cotyledons from Fresh Lotus Seeds during Postharvest Storage",
    "LFB15": "Comparative Transcriptome of Lotus Flower Buds",
    "PD21": "Transcriptome of Lotus Peduncle Development",
    "SUSS9": "Transcriptome of Lotus Seedlings under Salt Stress",
    "FLSPS15": "Transcriptome of Pericarps from Fresh Lotus Seeds during Postharvest Storage",
    "CRMMLP27": "Comparative Transcriptome of Cotyledons Reveals the Molecular Mechanism of Low-Temperature Preservation",
    "SD12": "Transcriptome of Lotus Stamen Development",
    "SUST12": "Transcriptome of Lotus Seedpods under shading treatment",
    "D49": "Transcriptome of Different Lotus Tissues"
  }
const optionsArr=[]
Object.keys(AnaSelectOptions).map(key=>{
    optionsArr.push({
        key:key,
        label:AnaSelectOptions[key],
        value:key,
    })
})
export {optionsArr,AnaSelectOptions}